import validator from 'validator';
import i18n from "shared/i18n";

const validate = (fieldName, fieldValue, required = false) => {
  let errors = null;
  if (!fieldValue && typeof fieldValue !== 'boolean' && required) { // typeof fieldValue !== 'boolean' ---> it ignores Checkboxes
    errors = {};
    errors[fieldName] = i18n.t("This field is required");
  }
  if (fieldValue && typeof fieldValue !== 'boolean') {
    if (fieldValue && fieldName === 'tc_url') {
      if (!validator.isURL(fieldValue, { allow_underscores: true })) {
        errors = {};
        errors[fieldName] = i18n.t("Please enter a valid link");
      }
    }
  }
  return errors;
};

export default validate;
